export default "__VITE_ASSET__C$aHwYmE__"